Object.defineProperty(exports, "__esModule", { value: true });
exports.compileSchema = void 0;
const graphql_1 = require("graphql");
const registry_1 = require("./registry");
const error_1 = require("./error");
const services_1 = require("./services");
const interfaceTypeRegistry_1 = require("../interfaceType/interfaceTypeRegistry");
const registry_2 = require("../objectType/registry");
function getAllRootFieldsFromRegistry(roots, registry, name) {
    const allRootFields = {};
    for (const root of roots) {
        const rootFields = registry.getAll(root);
        Object.keys(rootFields).forEach((fieldName) => {
            const fieldConfigGetter = rootFields[fieldName];
            const fieldConfig = fieldConfigGetter();
            // throw error if root field with this name is already registered
            if (!!allRootFields[fieldName]) {
                throw new error_1.SchemaRootError(root, `Duplicate of root field name: '${fieldName}'. Seems this name is also used inside other schema root.`);
            }
            allRootFields[fieldName] = fieldConfig;
        });
    }
    const isEmpty = Object.keys(allRootFields).length < 1;
    if (isEmpty) {
        return null;
    }
    return new graphql_1.GraphQLObjectType({
        name,
        fields: allRootFields
    });
}
function compileSchema(schemaOrSchemas) {
    const roots = Array.isArray(schemaOrSchemas)
        ? schemaOrSchemas
        : [schemaOrSchemas];
    services_1.validateSchemaRoots(roots);
    const query = getAllRootFieldsFromRegistry(roots, registry_1.queryFieldsRegistry, 'Query');
    const mutation = getAllRootFieldsFromRegistry(roots, registry_1.mutationFieldsRegistry, 'Mutation');
    if (!query) {
        throw new Error('At least one of schema roots must have @Query root field.');
    }
    const extraTypes = [];
    Array.from(interfaceTypeRegistry_1.interfaceClassesSet).forEach((interfaceClass) => {
        const implementorClasses = interfaceTypeRegistry_1.interfaceTypeImplementors.get(interfaceClass);
        if (Array.isArray(implementorClasses)) {
            implementorClasses.forEach((implementorClass) => {
                const implementor = registry_2.objectTypeRegistry.get(implementorClass)();
                extraTypes.push(implementor);
            });
        }
        else {
            throw new Error(`interface type ${interfaceClass.name} doesn't have any implementors`);
        }
    });
    return new graphql_1.GraphQLSchema({
        query: query || undefined,
        mutation: mutation || undefined,
        types: extraTypes
    });
}
exports.compileSchema = compileSchema;
//# sourceMappingURL=compiler.js.map